

















































import { defineComponent, PropType, ref, watch } from '@vue/composition-api'
import { getRegions } from '~/api/Address/address'
import { getAgencies } from '~/api/Agency/agency.api'
import { autoUpController } from '~/api/Remittances/remittances.api'
import Autocomplete from '~/components/Autocomplete.vue'
import CreateDialog from '~/components/CreateDialog.vue'
import { crudEditComposition } from '~/compositions/crudEditComposition'
import { Region } from '~/utils/interfaces'
import {
  AutoUp,
  DeliveryCurrenciesEnum,
} from '~/utils/interfaces/remittance.interface'
import vRules from '~/utils/vRules'

export default defineComponent({
  components: { CreateDialog, Autocomplete },
  props: {
    value: { type: Boolean, default: false },
    editedItem: Object as PropType<AutoUp>,
  },
  setup(props, ctx) {
    const model = ref(props.value)
    watch(
      () => props.value,
      value => (model.value = value),
    )
    watch(model, value => ctx.emit('input', value))
    const composition = crudEditComposition(
      props,
      ctx,
      {
        regions: [],
        agency: '',
        delivery_currency: '',
      },
      autoUpController.createOrUpdateJson,
    )
    return {
      model,
      ...composition,
      vRules,
    }
  },
  data() {
    return {
      getAgencies,
      currencyItems: Object.values(DeliveryCurrenciesEnum),
      regions: [] as Region[],
    }
  },
  async mounted() {
    const response = await getRegions({ country__name: 'Cuba', limit: 20 })
    this.regions = response.data.results
  },
})
